import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type INIPEZModel = IEnumeratorModel;
export const NIPEZModelAttrMap = createEnumeratorAttrMap('NIPEZ');
